import { JSONSchema6 } from "json-schema";
 
const createReportSchema: JSONSchema6 = {
    title: "Create Report",
    description: "Create Report initiates a report generation request using the specified report type and date range.",
    properties: {
        "header": {
            type: "object",
            properties: {
                "x-amz-pay-idempotency-key": {
                  title: "x-amz-pay-idempotency-key",
                  type: "string"
                }
            },
            required: ["x-amz-pay-idempotency-key"]
        },
        "payload": {
            type: "object",
            properties: {
                "reportType": {
                    type: "string",
                    enum: ["_GET_FLAT_FILE_OFFAMAZONPAYMENTS_SANDBOX_SETTLEMENT_DATA_"],
                    default: "_GET_FLAT_FILE_OFFAMAZONPAYMENTS_SANDBOX_SETTLEMENT_DATA_"
                },
                "startTime": {
                    type: "string"
                },
                "endTime": {
                    type: "string"
                }
            },
            required: ["reportType", "startTime", "endTime"]
        }
    },
    required: ["header", "payload"]
}
 
export default createReportSchema;